"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHomeownersWithHubsListView = exports.useCustomersListView = exports.useDeleteCustomer = exports.useUpdateCustomer = exports.useCreateCustomer = exports.useCustomerByPhone = exports.useCustomerByEmail = exports.useCustomer = exports.useCustomers = void 0;
const react_1 = require("react");
const mutations_1 = require("../graphql/mutations");
const queries_1 = require("../graphql/queries");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
const useCustomers = (filter) => {
    const [customers, setCustomers] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        fetchCustomers();
    }, [filter]);
    const fetchCustomers = async () => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listCustomers,
                variables: { limit: 60 },
                authMode: 'userPool',
            });
            if (response && response.data) {
                let items = [];
                if (Array.isArray(response.data.listCustomers)) {
                    items = response.data.listCustomers;
                }
                else if (response.data.listCustomers &&
                    Array.isArray(response.data.listCustomers.items)) {
                    items = response.data.listCustomers.items;
                }
                else if (response.data.listCustomers) {
                    items = [response.data.listCustomers];
                }
                setCustomers(items);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setCustomers([]);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching customers:', err);
        }
        finally {
            setLoading(false);
        }
    };
    const refetch = () => {
        fetchCustomers();
    };
    const getCustomerById = async (id) => {
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getCustomer,
                variables: { id },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.getCustomer) {
                return response.data.getCustomer;
            }
            else {
                console.warn('Customer not found:', id);
                return null;
            }
        }
        catch (err) {
            console.error('Error fetching customer by ID:', err);
            return null;
        }
    };
    return { customers, loading, error, refetch, getCustomerById };
};
exports.useCustomers = useCustomers;
const useCustomer = (id) => {
    const [customer, setCustomer] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (id) {
            fetchCustomer(id);
        }
    }, [id]);
    const fetchCustomer = async (id) => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getCustomer,
                variables: { id },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.getCustomer) {
                setCustomer(response.data.getCustomer);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setCustomer(null);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching customer:', err);
        }
        finally {
            setLoading(false);
        }
    };
    const refetch = (id) => {
        if (id) {
            fetchCustomer(id);
        }
    };
    return { customer, refetch, loading, error };
};
exports.useCustomer = useCustomer;
const useCustomerByEmail = (email) => {
    const [customer, setCustomer] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (email) {
            fetchCustomer();
        }
    }, [email]);
    const fetchCustomer = async () => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listCustomers,
                variables: { limit: 100 },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.listCustomers) {
                let items = [];
                if (Array.isArray(response.data.listCustomers)) {
                    items = response.data.listCustomers;
                }
                else if (response.data.listCustomers &&
                    Array.isArray(response.data.listCustomers.items)) {
                    items = response.data.listCustomers.items;
                }
                const foundCustomer = items.find((c) => c.email === email);
                setCustomer(foundCustomer || null);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setCustomer(null);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching customer by email:', err);
        }
        finally {
            setLoading(false);
        }
    };
    return { customer, loading, error };
};
exports.useCustomerByEmail = useCustomerByEmail;
const useCustomerByPhone = (phone) => {
    const [customer, setCustomer] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (phone) {
            fetchCustomer();
        }
    }, [phone]);
    const fetchCustomer = async () => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listCustomers,
                variables: { limit: 100 },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.listCustomers) {
                let items = [];
                if (Array.isArray(response.data.listCustomers)) {
                    items = response.data.listCustomers;
                }
                else if (response.data.listCustomers &&
                    Array.isArray(response.data.listCustomers.items)) {
                    items = response.data.listCustomers.items;
                }
                const foundCustomer = items.find((c) => c.phone === phone);
                setCustomer(foundCustomer || null);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setCustomer(null);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching customer by phone:', err);
        }
        finally {
            setLoading(false);
        }
    };
    return { customer, loading, error };
};
exports.useCustomerByPhone = useCustomerByPhone;
const useCreateCustomer = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const create = async (input) => {
        try {
            setLoading(true);
            setError(null);
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.createCustomer,
                variables: { input },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.createCustomer) {
                return response.data.createCustomer;
            }
            else {
                console.warn('Unexpected API response structure:', response);
                return null;
            }
        }
        catch (err) {
            setError(err);
            console.error('Error creating customer:', err);
            return null;
        }
        finally {
            setLoading(false);
        }
    };
    return { create, loading, error };
};
exports.useCreateCustomer = useCreateCustomer;
const useUpdateCustomer = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const update = async (input) => {
        try {
            setLoading(true);
            setError(null);
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.updateCustomer,
                variables: { input },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.updateCustomer) {
                return response.data.updateCustomer;
            }
            else {
                console.warn('Unexpected API response structure:', response);
                return null;
            }
        }
        catch (err) {
            setError(err);
            console.error('Error updating customer:', err);
            return null;
        }
        finally {
            setLoading(false);
        }
    };
    return { update, loading, error };
};
exports.useUpdateCustomer = useUpdateCustomer;
const useDeleteCustomer = () => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const remove = async (id) => {
        try {
            setLoading(true);
            setError(null);
            const response = await amplifyBootstrap_1.API.graphql({
                query: mutations_1.deleteCustomer,
                variables: { id },
                authMode: 'userPool',
            });
            if (response && response.data && response.data.deleteCustomer) {
                return response.data.deleteCustomer;
            }
            else {
                console.warn('Unexpected API response structure:', response);
                return null;
            }
        }
        catch (err) {
            setError(err);
            console.error('Error deleting customer:', err);
            return null;
        }
        finally {
            setLoading(false);
        }
    };
    return { remove, loading, error };
};
exports.useDeleteCustomer = useDeleteCustomer;
const useCustomersListView = () => {
    const [customerOverviews, setCustomerOverviews] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        fetchCustomers();
    }, []);
    const fetchCustomers = async (filter) => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listCustomersOverview,
                variables: { limit: 60, text: filter?.text },
                authMode: 'userPool',
            });
            if (response && response.data) {
                let items = [];
                if (Array.isArray(response.data.listCustomersOverview)) {
                    items = response.data.listCustomersOverview;
                }
                else if (response.data.listCustomersOverview &&
                    Array.isArray(response.data.listCustomersOverview.items)) {
                    items = response.data.listCustomersOverview.items;
                }
                else if (response.data.listCustomersOverview) {
                    items = [response.data.listCustomersOverview];
                }
                setCustomerOverviews(items);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setCustomerOverviews([]);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching customers:', err);
        }
        finally {
            setLoading(false);
        }
    };
    const refetch = (filter) => {
        fetchCustomers(filter);
    };
    return { customerOverviews, loading, error, refetch };
};
exports.useCustomersListView = useCustomersListView;
const useHomeownersWithHubsListView = () => {
    const [homeownerOverviews, setHomeownerOverviews] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        fetchHomeowners();
    }, []);
    const fetchHomeowners = async (filter) => {
        try {
            setLoading(true);
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.listHomeownersWithHubs,
                variables: { limit: 60, text: filter?.text },
                authMode: 'userPool',
            });
            if (response && response.data) {
                let items = [];
                if (Array.isArray(response.data.listHomeownersWithHubs)) {
                    items = response.data.listHomeownersWithHubs;
                }
                else if (response.data.listHomeownersWithHubs &&
                    Array.isArray(response.data.listHomeownersWithHubs.items)) {
                    items = response.data.listHomeownersWithHubs.items;
                }
                else if (response.data.listHomeownersWithHubs) {
                    items = [response.data.listHomeownersWithHubs];
                }
                setHomeownerOverviews(items);
            }
            else {
                console.warn('Unexpected API response structure:', response);
                setHomeownerOverviews([]);
            }
            setError(null);
        }
        catch (err) {
            setError(err);
            console.error('Error fetching homeowners with hubs:', err);
        }
        finally {
            setLoading(false);
        }
    };
    const refetch = (filter) => {
        fetchHomeowners(filter);
    };
    return { homeownerOverviews, loading, error, refetch };
};
exports.useHomeownersWithHubsListView = useHomeownersWithHubsListView;
